import React from "react";
import { Select } from "components/common";
import { Button, ButtonToolbar, Col, ControlLabel, FormGroup, HelpBlock, Row } from "components/bootstrap";
import EventNotificationFormContainer from "components/event-notifications/event-notification-form/EventNotificationFormContainer";
import withTelemetry from "logic/telemetry/withTelemetry";
import { getPathnameWithoutId } from "util/URLUtils";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import withLocation from "routing/withLocation";
import commonStyles from "../common/commonStyles.css";
class AddNotificationForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleNewNotificationSubmit = (promise) => {
      this.props.sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.DONE_CLICKED, {
        app_pathname: getPathnameWithoutId(this.props.location.pathname),
        app_section: "event-definition-notifications",
        app_action_value: "done-button"
      });
      const { onChange } = this.props;
      promise.then((notification) => onChange(notification.id));
    };
    this.handleSubmit = () => {
      this.props.sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.DONE_CLICKED, {
        app_pathname: getPathnameWithoutId(this.props.location.pathname),
        app_section: "event-definition-notifications",
        app_action_value: "done-button"
      });
      const { onChange } = this.props;
      const { selectedNotification } = this.state;
      onChange(selectedNotification);
    };
    this.handleCancel = () => {
      this.props.sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.CANCEL_CLICKED, {
        app_pathname: getPathnameWithoutId(this.props.location.pathname),
        app_section: "event-definition-notifications",
        app_action_value: "cancel-button"
      });
      this.props.onCancel();
    };
    this.handleSelectNotificationChange = (nextNotificationId) => {
      if (nextNotificationId === "create") {
        this.props.sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.CREATE_NEW_CLICKED, {
          app_pathname: getPathnameWithoutId(this.props.location.pathname),
          app_section: "event-definition-notifications",
          app_action_value: "create-new-option"
        });
        this.setState({ displayNewNotificationForm: true });
        return;
      }
      this.props.sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.NOTIFICATION_SELECTED, {
        app_pathname: getPathnameWithoutId(this.props.location.pathname),
        app_section: "event-definition-notifications",
        app_action_value: "existing-notification-option"
      });
      this.setState({ selectedNotification: nextNotificationId, displayNewNotificationForm: false });
    };
    this.formatNotifications = (notifications) => {
      const { hasCreationPermissions } = this.props;
      const formattedNotifications = notifications.map((n) => ({ label: n.title, value: n.id }));
      if (hasCreationPermissions) {
        formattedNotifications.unshift({
          label: "Create New Notification...",
          value: "create"
        });
      }
      return formattedNotifications;
    };
    this.state = {
      selectedNotification: void 0,
      displayNewNotificationForm: false
    };
  }
  render() {
    const { notifications } = this.props;
    const { displayNewNotificationForm, selectedNotification } = this.state;
    const doneButton = displayNewNotificationForm ? /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", type: "submit", form: "new-notification-form" }, "Add notification") : /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: this.handleSubmit, disabled: !selectedNotification }, "Add notification");
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 7, lg: 6 }, /* @__PURE__ */ React.createElement("h2", { className: commonStyles.title }, "Add Notification"), /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "notification-select" }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Choose Notification"), /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "notification-select",
        placeholder: "Select Notification",
        onChange: this.handleSelectNotificationChange,
        options: this.formatNotifications(notifications),
        value: selectedNotification,
        menuPlacement: "bottom"
      }
    ), /* @__PURE__ */ React.createElement(HelpBlock, null, "Select a Notification to use on Alerts of this kind or create a new Notification that you can later use in other Alerts.")), displayNewNotificationForm && /* @__PURE__ */ React.createElement(
      EventNotificationFormContainer,
      {
        action: "create",
        formId: "new-notification-form",
        onSubmit: this.handleNewNotificationSubmit,
        embedded: true
      }
    )), /* @__PURE__ */ React.createElement(ButtonToolbar, null, doneButton, /* @__PURE__ */ React.createElement(Button, { onClick: this.handleCancel }, "Cancel"))));
  }
}
AddNotificationForm.defaultProps = {
  hasCreationPermissions: false
};
export default withLocation(withTelemetry(AddNotificationForm));
